import { FT, Console } from 'ft'
import Preloader from './scenes/Preloader'
import Intro from './scenes/Intro'
import Porch from './scenes/Porch'
import Bedroom from './scenes/Bedroom'
import Bed from './scenes/Bed'
import './stats'

new Console()

FT.initialize('#container')

FT.sm.register('preloader', Preloader)
FT.sm.register('intro', Intro)
FT.sm.register('porch', Porch)
FT.sm.register('bedroom', Bedroom)
FT.sm.register('bed', Bed)
FT.sm.load('preloader')

FT.start()
